import { useBoolean } from "@/hooks/use-boolean";
import useTranslation from "@babackapp/translations/use-translation";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@babackapp/ui/components/dialog";
import { Separator } from "@radix-ui/react-select";
import { PropsWithChildren } from "react";
import { AddDomainForm } from "./add-domain-form";

export function AddDomainDialog({ children }: PropsWithChildren) {
  const t = useTranslation();
  const dialogOpen = useBoolean();

  const onSubmit = async () => {
    dialogOpen.setFalse();
  };

  return (
    <Dialog open={dialogOpen.value} onOpenChange={dialogOpen.setValue}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="pt-10">
        <DialogHeader>
          <DialogTitle>{t("settings.domains.popUp.title")}</DialogTitle>
          <DialogDescription></DialogDescription>
          {t("settings.domains.popUp.description")}
        </DialogHeader>
        <Separator className="mt-2" />
        <AddDomainForm onSuccess={onSubmit} />
      </DialogContent>
    </Dialog>
  );
}
